import { Flex, PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { ApplicationPageStepper, DocumentUploadSupportingContent } from "../../../components";
import { PAGE_TYPE, useFundingApplicationNavigation } from "../../../hooks/navigation-next";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { DocumentNavigationGroup, SusaDocumentUpload } from "../components";

export const SusaDocumentUploadPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter((doc) => doc.documentType === UploadDocumentType.SUSA)
    .length;

  const navigationContext = useFundingApplicationNavigation({
    currentPage: PAGE_TYPE.DOCUMENTS,
    currentStep: UploadDocumentType.SUSA,
  });

  const SusaDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <SusaDocumentUpload />
      <DocumentNavigationGroup isStepComplete={hasUploadedDocuments} forType={UploadDocumentType.SUSA} />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<ApplicationPageStepper currentStepIndex={1} />}
      showStepperBackground={true}
      title={intl.formatMessage({
        id: "funding-application: upload company susa",
        defaultMessage: "Upload your company SUSA",
      })}
      primaryContent={SusaDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
      titleKicker={navigationContext.stepString}
    />
  );
};
